import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './styles.scss';

ProjectItem.propTypes = {
    item: PropTypes.object,
};

function ProjectItem(props) {

    const {item} = props;
    const detailPath = `/nft-item-details/${item.id}`;

    return (
        <div className="img-box">
            <Link to={detailPath} aria-label={`View Block Pirate ${item.id}`}>
                <img src={item.img} alt={`Block Pirate ${item.id}`} />
            </Link>
            <div className="content">
                <Link to={detailPath}>Block Pirate #{item.id}</Link>
            </div>
        </div>
    );
}

export default ProjectItem;
